<template>
  <div class="my_icon_select_index">
   <p :class="type == 'one_level' ? 'set_one_level': 'set_two_level'">
     <span v-text="title" class="title" :style="{
      width: titleWidth+ 'px'
     }"></span>
     <el-select
       popper-class="icon_select_dropdown"
       :style="{
       width: width + 'px'
       }"
       class="module"
       v-model="Result"
       :placeholder="placeholder"
       :disabled="disabled"
       size="small"
       @visible-change="visible_change"
       @change="change">
       <el-option
         v-for="item in options"
         :key="item.icon"
         :label="$t(item.label)"
         :value="item.value">
         <i class="dropdown_item">
           <span :class="item.icon"></span>
           <span v-text="$t(item.label)" :class="item.icon.indexOf('scale') > -1 ? '' : 'text'"></span>
         </i>
       </el-option>
     </el-select>
   </p>
  </div>
</template>

<script>
  export default {
    name:'my_icon_select_index',
    props:{
      title: { // 组件的标题
        type:String,
        default: ''
      },
      keyType: {
        type:String,
        default: ''
      },
      type: { // 组件的类型  one_level 一级组件 two_level 二级组件
        type:String,
        default: 'two_level'
      },
      value: { // 输入框的值
      },
      placeholder: {
        type:String,
        default: ''
      },
      disabled: {
        type:Boolean,
        default: false
      },
      options:{ // 数组
        type:Array,
        default:function () {
          return []
        }
      },
      width: {
        type:String,
        default: '160'
      },
      titleWidth: {
        type:String,
        default: '40'
      }
    },
    data(){
      return {
        Result:this.value
      }
    },
    mounted() {
    },
    watch:{
      Result(val){
        this.$emit('update:value',val);//双向数据绑定
      },
      value(val){
        this.Result = this.value
      }
    },
    computed:{
    },
    methods:{
      change(){
        this.$emit('change',this.Result);
        if(this.keyType == 'img_scale') {
          this.$emit("imgScaleChange", this.Result);
        } else {
          this.$emit("tileEffectChange", this.Result);
        }
      },
      visible_change (val) {
        if (val) {
          $(".main_dialog").draggable('disable')
        } else {
          $(".main_dialog").draggable('enable')
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/my_icon_select/index.vue